module.exports = __webpack_public_path__ + "img/new-error.92ec9bcf.svg";